module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_library.js
// module id = 258
// module chunks = 2